import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PlaceIcon from '@mui/icons-material/Place';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PaymentsIcon from '@mui/icons-material/Payments';
import { metaStripStyles } from './eventDetailsStyles';

const metaItems = [
  { label: 'Starts', icon: CalendarMonthIcon },
  { label: 'Venue', icon: PlaceIcon },
  { label: 'Price', icon: PaymentsIcon },
  { label: 'Availability', icon: ConfirmationNumberIcon },
];

const EventMetaStrip = ({ start, venue, price, availability }) => {
  const values = [start, venue, price, availability];

  return (
    <Container maxWidth="lg" sx={metaStripStyles.shell}>
      <Card sx={metaStripStyles.card}>
        <CardContent>
          <Grid container spacing={2}>
            {metaItems.map((item, index) => {
              const MetaIcon = item.icon;
              return (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
                  <Stack direction="row" spacing={1.25} alignItems="center">
                    <MetaIcon sx={metaStripStyles.icon} />
                    <Box>
                      <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                      <Typography variant="body2" sx={metaStripStyles.value}>{values[index]}</Typography>
                    </Box>
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default EventMetaStrip;
